import Near from "../../assets/img/logo/near.svg";
import ETH from "../../assets/img/logo/eth.svg";
import Sol from "../../assets/img/logo/sol.svg";

// NFTS
import One from "../../assets/img/nfts/1.png";
import Two from "../../assets/img/nfts/2.png";
import Three from "../../assets/img/nfts/3.png";
import Four from "../../assets/img/nfts/4.png";
import Five from "../../assets/img/nfts/5.png";
import Six from "../../assets/img/nfts/6.png";

export const nfts = [
  {
    album: "Happy Times", 
    artist: "James Kelvin",
    song: "/song.mp3",
    platform: "Mintbase.id",
    price: 0.24,
    likes: "104", 
    liked: true,
    token: Near,
    img: One,
  },
  {
    album: "Already Dead", 
    artist: "Selina Amber",
    song: "/songtwo.mp3",
    platform: "Mintbase.id",
    price: 0.24,
    likes: 0,
    liked: false,
    token: ETH,
    img: Two,
  },
  {
    album: "Country Home", 
    artist: "John Jones",
    song: "/song3.mp3",
    platform: "Mintbase.id",
    price: 0.24,
    likes: "1.24k",
    liked: true,
    token: Sol,
    img: Three,
  },
  {
    album: "Heart", 
    artist: "Chris Walker",
    song: "/song4.mp3",
    platform: "Mintbase.id",
    price: 0.24,
    likes: 104,
    liked: true,
    token: Near,
    img: Four,
  },
  {
    album: "Bay", 
    artist: "Peace J",
    song: "/song.mp3",
    platform: "Mintbase.id",
    price: 0.24,
    likes: "1.2k",
    liked: true,
    token: Sol,
    img: Five,
  },
  {
    album: "Jazz Blues", 
    artist: "Doe Joe",
    song: "/song3.mp3",
    platform: "Mintbase.id",
    price: 0.24,
    likes: 102,
    liked: false,
    token: Near,
    img: Six,
  },
];
